import React, { useContext } from 'react'
import { OaCostWkHeaders } from './../Headers'
import { EditableGrid } from 'core'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
import {
  defaultVirtualizedCellRender,
  freeEditEngine,
} from '@integec/grid-tools'
import { Button, Spin, Modal, message } from 'antd'
import { SpinContext, ErrorContext } from 'context'
import moment from 'moment'
import { marginAnalysisValidate } from 'api/pgads'

const CostConstraintGridDioalog = ({
  targetInfo,
  visible,
  onClose,
  height,
  width,
  whatIfAdmin,
  lostType,
  // eslint-disable-next-line no-unused-vars
  ...props
}) => {
  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)

  const {
    WFRetrieveData = {},
    costDataEditInfo,
    setCostDataEditInfo,
    handleWFRetrieveData,
  } = useContext(MarginAnalysisContext)
  const { costData = [] } = WFRetrieveData

  const saveData = _ => {
    if (!whatIfAdmin) {
      onClose()
      return
    }
    const { request, costData } = WFRetrieveData

    let saveCostData = freeEditEngine.applyEdits({
      data: costData,
      editInfo: costDataEditInfo,
    })

    if (
      saveCostData.find(d => (d.effectivedateStr || '').trim().length === 0)
    ) {
      message.error('Please, Correct data')
      return
    }

    saveCostData = saveCostData.map(d => ({
      ...d,
      transdate: moment(d.effectivedateStr).format('YYYY-MM-DD'),
      isValidDate: moment(d.effectivedateStr).isValid(),
    }))

    if (saveCostData.find(d => !d.isValidDate)) {
      message.error('Please,Correct Date')
      return
    }

    setSpinning(true)
    marginAnalysisValidate(targetInfo)({
      ...WFRetrieveData,
      costData: saveCostData,
      request: { ...request, lostType, mode: 'WHATIF' },
    }).fork(setError, data => {
      setSpinning(false)
      handleWFRetrieveData(data, onClose)
    })
  }

  return (
    <Modal
      maskClosable={false}
      title={whatIfAdmin ? 'Edit Constraints' : 'View Constraints'}
      height={height}
      width={width}
      visible={visible}
      onCancel={onClose}
      okText="Save"
      onOk={saveData}
      destroyOnClose
      afterClose={onClose}
      bodyStyle={{ minHeight: height + 'px' }}
      confirmLoading
      footer={
        <div>
          <Button onClick={onClose} loading={spinning}>
            Cancel
          </Button>
          <Button
            style={{ marginLeft: '20px' }}
            type="primary"
            onClick={saveData}
            loading={spinning}
          >
            {whatIfAdmin ? 'Save Constraints' : 'OK'}
          </Button>
        </div>
      }
    >
      <Spin spinning={spinning}>
        <EditableGrid
          isEditable={whatIfAdmin}
          height={height - 20}
          width={width - 50}
          header={OaCostWkHeaders}
          setEditInfo={setCostDataEditInfo}
          data={costData}
          editInfo={costDataEditInfo}
          setData={_ => _}
          cellRender={defaultVirtualizedCellRender}
          headerRowHeight={50}
        />
      </Spin>
    </Modal>
  )
}

export default CostConstraintGridDioalog
